// extracted by mini-css-extract-plugin
export default {"header-container":"header_header-container__YO636"};